import { createFileRoute } from "@tanstack/react-router";
import { RouteError, RouteNotFound } from "@/components/route-error";
import { ContactDetailBody } from "@/components/contact-detail-body";

export const Route = createFileRoute("/_authenticated/contacts/$contactId")({
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: ContactDetailRoute,
  validateSearch: (s: Record<string, unknown>): { discover?: 1 } =>
    s.discover === 1 || s.discover === "1" ? { discover: 1 } : {},
});

function ContactDetailRoute() {
  const { contactId } = Route.useParams();
  const search = Route.useSearch();
  return <ContactDetailBody contactId={contactId} discover={search.discover === 1} mode="page" />;
}
